import { makeAutoObservable, runInAction } from 'mobx'
import posthog, { Survey, SurveyQuestion } from 'posthog-js'

import { GlobalStore } from './GlobalStore'

export class AnalyticsStore {
  globalStore: GlobalStore
  survey: Survey | null = null
  currentQuestionIndex: number = 0
  question: SurveyQuestion | null = null
  response: number | string | null = null
  responses: Record<string, number | string | null> = {}

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    makeAutoObservable(this)
  }

  get isLastQuestion() {
    return this.currentQuestionIndex === this.surveyQuestions.length - 1
  }

  get questionCount() {
    return `${this.currentQuestionIndex + 1}/${this.surveyQuestions.length}`
  }

  get responsePayload() {
    return {
      $survey_id: this.surveyId,
      ...this.responses,
    }
  }

  // TODO hardcode elsewhere
  get surveyId() {
    const posthogKey = window.app?.postHogPublicKey

    return posthogKey === 'phc_KclQGnOZEaYCttkpiVpuyOYeBlixGo6xNphYgWV4CXo'
      ? '0196caa6-9b37-0000-98a7-f04e8d56faf5'
      : '0196a6b0-ccde-0000-b980-0b84ea2fef4a'
  }

  get surveyQuestions() {
    return this.survey ? this.survey.questions : ([] as SurveyQuestion[])
  }

  loadSurvey = (forceReload: boolean = false) => {
    posthog.getActiveMatchingSurveys((surveys) => {
      runInAction(() => {
        if (surveys.length > 0) {
          const survey = surveys.find((s) => s.id === this.surveyId)
          if (survey) {
            this.survey = survey
            this.currentQuestionIndex = 0
            this.question = survey.questions[0]
            this.response = null
            this.responses = {}
          }
        }
      })
    }, forceReload)
  }

  nextQuestion = () => {
    if (this.currentQuestionIndex < this.surveyQuestions.length - 1) {
      this.currentQuestionIndex += 1
    }
    this.response = null
    this.question = this.surveyQuestions[this.currentQuestionIndex]
  }

  resetStore = () => {
    this.survey = null
    this.currentQuestionIndex = 0
    this.question = null
    this.response = null
    this.responses = {}
  }

  setResponse = (response: number | string | null) => {
    this.response = response
    if (this.question) {
      this.responses[`$survey_response_${this.question.id}`] = response
    }
  }
}
